module.exports = __webpack_public_path__ + "static/media/radio.2aacbe1e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/Header/components/Title/Icons/radio.svg
// module id = 74
// module chunks = 0